
const notPoBoxRegExp = new RegExp('(?:P(?:ost(?:al)?)?[\\.\\-\\s]*(?:(?:O(?:ffice)?[\\.\\-\\s]*)' +
  '?B(?:ox|in|\\b|\\d)|o(?:ffice|\\b)(?:[-\\s]*\\d)|code)|box[-\\s\b]*\\d)', 'i')

export function isPoBox(text: string): boolean {
  return notPoBoxRegExp.test(text)
}
